<template>
	<app-content class="h-panel">
          <!-- 头部选项卡    -->
		<Tabs :datas="tabDatas" v-model="selected" @change="change"></Tabs>
          <!-- 按钮操作区域   -->
		<div class="padding-right-left padding-top">
			<span class="dark4-color">*提示：按 Ctrl + F 键并输入科目编码或者科目名称可以查找科目。</span>
			<div class="pull-right">
        <Button :disabled="!selectedSubjects.length" @click="showBatchAssisting" color="normal">批量设置辅助核算</Button>
        <Button @click="encodingSetting">编码设置</Button>
				<Button @click="create()" v-if="currentAccountSets.accountingStandards !== 0" color="primary">新增科目</Button>
				<Button @click="encodingSetting">编码设置</Button>
<!--				<Button :loading="loading" @click="doUpload">-->
<!--					<input ref="file" type="file" accept="application/vnd.ms-excel" style="display: none" @change="fileChange($event)">-->
<!--					导入-->
<!--				</Button>-->
        <Button type="primary" @click="exportExcel">导出当前页</Button>
        <Button type="primary" @click="exportExcelAll">导出全部</Button>
			</div>
		</div>
          <!-- 表格区域   -->
		<div class="h-panel-body padding">
<!--			<Table :datas="datas" border :loading="loading">-->
      <Table :datas="datas" border :loading="loading" @select="handleSelectChange" :checkbox="true">
        <TableItem title="序号" :width="50">
          <template v-slot="{ index, data }">
            {{  index + 1 }}
          </template>
        </TableItem>
				<TableItem title="科目编码">
					<template slot-scope="{data}">
						<span :style="{paddingLeft:(data.level-1)*15+'px'}">{{data.code}}</span>
					</template>
				</TableItem>
				<TableItem title="科目名称" prop="name"></TableItem>
				<TableItem title="助记码" prop="mnemonicCode"></TableItem>
				<TableItem title="余额方向" prop="balanceDirection" align="center" :width="100"></TableItem>
				<TableItem title="数量核算" v-if="showUnit" prop="unit" align="center" :width="100"></TableItem>
        <!-- 辅助核算列，仅在存在辅助核算数据时显示 -->
        <TableItem title="辅助核算" v-if="showAssistAccounting">
          <!-- 解构获取行数据的 auxiliaryAccounting 字段 -->
          <template slot-scope="{data:{auxiliaryAccounting}}">
            <!-- 若 auxiliaryAccounting 存在，则解析 JSON 字符串并提取所有名称，用逗号分隔显示 -->
            {{auxiliaryAccounting?JSON.parse(auxiliaryAccounting).map(val=>val.name).join(','):''}}
					</template>
				</TableItem>
				<TableItem title="状态" align="center" :width="100">
					<template slot-scope="{data}">
						{{data.status?"正常":"不可用"}}
					</template>
				</TableItem>
				<TableItem title="操作" :width="150" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="create(data)" v-if="data.level < 3">新增</span>
						<span v-if="!data.isLeaf" @click="edit(data)">编辑</span>
						<span v-if="!data.systemDefault" @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>
		<Modal v-model="showForm" type="drawer-right" hasCloseIcon>
			<div slot="header">新增科目</div>
			<Form :readonly="used" ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
				<img v-if="used" class="used" src="@/assets/used.png" alt="已使用">
				<FormItem label="科目编码" prop="code">
					<div class="h-input-group" v-if="!form.id && parent">
						<span class="h-input-addon bg-white-color" style="padding-right: 0;border-right: none;line-height: 32px;;color: #001529;">{{parent.code}}</span>
						<input style="padding-left: 0;border-left: none;" type="text" v-model="form.code" :maxlength="len">
					</div>
					<input v-else-if="!form.id && !parent" type="text" v-model="form.code" :maxlength="len">
					<input v-else type="text" v-model="form.code" disabled>
				</FormItem>
				<FormItem label="科目名称" prop="name">
					<input type="text" v-model="form.name" :disabled="form.systemDefault || used">
				</FormItem>
				<FormItem label="上级科目">
					<input type="text" :value="parentSubject" disabled>
				</FormItem>
				<FormItem label="余额方向">
					<Radio v-model="form.balanceDirection" :datas="['借','贷']" :disabled="!!parent"/>
				</FormItem>
				<FormItem label="状态">
					<Radio v-model="form.status" dict="statusRadios" :disabled="used"></Radio>
				</FormItem>
				<FormItem single label="">
					<Row type="flex" :space-x="10">
						<Cell>
							<Checkbox v-model="numberAccounting" :disabled="used">数量核算</Checkbox>
						</Cell>
						<template v-if="numberAccounting">
							<Cell class="label">计量单位</Cell>
							<Cell><input type="text" v-width="100" v-model="unit" :disabled="used"></Cell>
						</template>
					</Row>
				</FormItem>
        <!-- 辅助核算设置表单项 -->
				<FormItem single label="">
          <!-- 使用 Flex 布局排列辅助核算选项 -->
					<Row type="flex" :space-x="10">
            <!-- 辅助核算总开关复选框 -->
						<Cell>
							<Checkbox v-model="assistAccounting" :disabled="used">辅助核算</Checkbox>
						</Cell>
            <!-- 当启用辅助核算时，显示具体的辅助核算类别选择 -->
						<template v-if="assistAccounting">
              <!-- 辅助核算类别多选框，从 accountingCategory 动态加载选项 -->
							<Cell>
								<Checkbox v-model="auxiliaryAccounting" :datas="accountingCategory" keyName="id" titleName="name" :disabled="used"></Checkbox>
							</Cell>
						</template>
					</Row>
				</FormItem>
			</Form>
			<div class="text-center">
				<Button color="green" @click="submit" :disabled="used" :loading="loading">{{form.id?'保存':'保存'}}</Button>
				<Button @click="showForm=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="encodingSettingForm">
			<div slot="header">科目编码设置</div>
			<div class="padding">
				科目编码设置：4 - <Select v-model="codeLen[1]" style="display: inline-block;" :datas="lenData" :deletable="false"/> - <Select v-model="codeLen[2]" style="display: inline-block;" :datas="lenData" :deletable="false"/> - <Select v-model="codeLen[3]" style="display: inline-block;" :datas="lenData2" :deletable="false"/>
			</div>
			<div class="text-center">
				<Button color="green" @click="saveEncoding" :loading="loading">保存</Button>
				<Button @click="encodingSettingForm=false" :loading="loading">取消</Button>
			</div>
		</Modal>

    <Modal v-model="showBatchAssistModal">
      <div slot="header">批量设置</div>
      <Form ref="batchForm" v-width="350" mode="twocolumn" :labelWidth="150">
        <FormItem single label="辅助核算">
          <Row type="flex" :space-x="1">
            <Cell>
              <Checkbox v-model="batchAssistAccounting" :datas="accountingCategory" keyName="id" titleName="name"></Checkbox>
            </Cell>
          </Row>
        </FormItem>
        <FormItem single label="">
          <Checkbox v-model="clearAuxiliary" :disabled="batchAssistAccounting && batchAssistAccounting.length > 0">清空辅助核算</Checkbox>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="batchSetAssistAccounting" :loading="loading">确定</Button>
        <Button @click="showBatchAssistModal=false">取消</Button>
      </div>
    </Modal>
	</app-content>
</template>

<script>

	import Pinyin from 'chinese-to-pinyin'
	import StringUtils from 'string-utilz'
	import {mapState} from 'vuex';
  import * as XLSX from 'xlsx';
	const emptyForm = {
		"code": "",
		"name": "",
		"mnemonicCode": "",
		"balanceDirection": "借",
		"auxiliaryAccounting": null,
		"status": true
	};
  /**
   * 用于实现科目管理功能。
   * 该组件包含科目列表展示、新增、编辑、删除科目，科目编码设置以及科目导入等功能。
   */
	export default {
		name: "Subject",
		data() {
			return {
				codeLen: [4, 2, 2, 2],
				lenData: [2, 3, 4],
				lenData2: [1, 2, 3, 4],
				tabDatas: [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
          title: '损益',
          key: 'CodeLoss'
        }, {
          title: '收入',
          key: 'CodeIncome'
        }, {
          title: '支出',
          key: 'CodeExpenditure'
        },{
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}],
        selected: 'CodeAssets',
				datas: [],
        DataAll: [],
				accountingCategory: [],
				auxiliaryAccounting: [],
				unit: '',
				validationRules: {
					required: ["code", "name"]
				},
				parent: null,
				len: 2,
				encodingSettingForm: false,
				numberAccounting: false,
				assistAccounting: false,
				form: HeyUtils.copy(emptyForm),
				showForm: false,
				used: false,
				type: "资产",
				loading: false,
        selectedSubjects: [],
        showBatchAssistModal: false,
        batchAssistAccounting: [],
        clearAuxiliary: false
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			parentSubject() {
				return this.parent ? this.parent.name : '';
			},
			showUnit() {
				return this.datas.find(value => !!value.unit)
			},
			showAssistAccounting() {
				return this.datas.find(value => !!value.auxiliaryAccounting)
			}
		},
		watch: {
			type() {
				this.loadList()
			},
			showForm(val) {
				if (!val) {
					this.parent = null;
					this.used = false;
					this.form = HeyUtils.copy(emptyForm);
					this.numberAccounting = false;
					this.assistAccounting = false;
					this.unit = '';
					this.auxiliaryAccounting = [];
				}
			},
			numberAccounting(val) {
				if (!val) {
					this.form.unit = '';
				}
			},
      showBatchAssistModal(val) {
        // 弹窗关闭时清空批量设置的状态
        if (!val) {
          this.batchAssistAccounting = [];
          this.clearAuxiliary = false;
        }
      },
		},
		methods: {

      exportExcelAll() {
        // 防止重复点击
        if (this.loading) return;

        this.loading = true;

        // 获取所有类型的科目数据
        const allTypes = this.tabDatas.map(tab => tab.title);
        const allDataPromises = allTypes.map(type =>
            this.$api.setting.subject.list(type).then(response => {
              // 为每个数据项添加类型标识
              const data = response.data || [];
              return data.map(item => ({
                ...item,
                type: type
              }));
            })
        );

        Promise.all(allDataPromises)
            .then(results => {
              // 合并所有类型的数据
              const allData = [].concat(...results);

              // 如果没有数据，提示用户
              if (!allData || allData.length === 0) {
                this.$Message.warning('当前没有可导出的数据');
                return;
              }

              // 准备导出的数据
              const exportData = allData.map(item => {
                return {
                  '科目类型': item.type,
                  '科目编码': item.code,
                  '科目名称': item.name,
                  '助记码': item.mnemonicCode,
                  '余额方向': item.balanceDirection,
                  '数量核算': item.unit || '',
                  '辅助核算': item.auxiliaryAccounting ?
                      JSON.parse(item.auxiliaryAccounting).map(val => val.name).join(',') : '',
                  '状态': item.status ? '正常' : '不可用'
                };
              });

              // 创建工作簿
              const ws = XLSX.utils.json_to_sheet(exportData);
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, ws, '全部科目数据');

              // 导出文件
              const filename = `全部科目数据_${new Date().toISOString().slice(0, 10)}.xlsx`;
              XLSX.writeFile(wb, filename);

              this.$Message.success('导出成功');
            })
            .catch(error => {
              this.$Message.error('导出失败: ' + error.message);
              console.error('Export error:', error);
            })
            .finally(() => {
              this.loading = false;
            });
      },



      exportExcel() {
        // 防止重复点击
        if (this.loading) return;

        // 如果没有数据，提示用户
        if (!this.datas || this.datas.length === 0) {
          this.$Message.warning('当前没有可导出的数据');
          return;
        }

        this.loading = true;

        try {
          // 准备导出的数据
          const exportData = this.datas.map(item => {
            return {
              '科目编码': item.code,
              '科目名称': item.name,
              '助记码': item.mnemonicCode,
              '余额方向': item.balanceDirection,
              '数量核算': item.unit || '',
              '辅助核算': item.auxiliaryAccounting ?
                  JSON.parse(item.auxiliaryAccounting).map(val => val.name).join(',') : '',
              '状态': item.status ? '正常' : '不可用'
            };
          });

          // 创建工作簿
          const ws = XLSX.utils.json_to_sheet(exportData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, '科目数据');

          // 导出文件
          const filename = `${this.type}科目数据_${new Date().toISOString().slice(0, 10)}.xlsx`;
          XLSX.writeFile(wb, filename);

          this.$Message.success('导出成功');
        } catch (error) {
          this.$Message.error('导出失败: ' + error.message);
          console.error('Export error:', error);
        } finally {
          this.loading = false;
        }
      },

      showBatchAssisting() {
        this.showBatchAssistModal = true;
      },

      encodingSetting() {
				this.encodingSettingForm = true;
			},
			saveEncoding() {
				let code = this.codeLen.join('-');
				if (code !== this.currentAccountSets.encoding) {
					this.loading = true;
					this.$api.setting.accountSets.updateEncode({encoding: this.currentAccountSets.encoding, newEncoding: code}).finally(() => {
						this.encodingSettingForm = false;
						this.loading = false;
					}).then(() => {
						this.loadList();
						this.$store.dispatch('init');
					});
				} else {
					this.encodingSettingForm = false;
				}
			},
			toPy() {
				let pyArr = [];
				this.form.name.split("").forEach(w => {
					w = w.trim();
					if (w) {
						if (/[\u4e00-\u9fa5]/.test(w)) {
							let py = Pinyin(w, {removeTone: true, keepRest: true}).trim();
							pyArr.push(py.substring(0, 1));
						} else {
							pyArr.push(w);
						}
					}
				});

				if (this.parent) {
					this.$set(this.form, 'mnemonicCode', this.parent.mnemonicCode + "_" + pyArr.join(""));
					if (!this.form.id) {
						this.$set(this.form, 'code', this.parent.code + this.form.code);
					}
				} else {
					this.$set(this.form, 'mnemonicCode', pyArr.join(""));
				}
			},
			loadList() {
				this.loading = true;
				this.$api.setting.subject.list(this.type).then(({data}) => {
					this.datas = data || [];
          // console.log(this.datas);
					this.loading = false
				});
			},
			loadAccountingCategory() {
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.accountingCategory = data;
				});
			},

      /**
       * 提交表单数据
       * 执行表单验证，处理辅助核算和数量核算数据，保存或更新科目信息
       */
			submit() {
        // 执行表单验证
				let validResult = this.$refs.form.valid();
				if (validResult.result) {
          // 生成助记码
					this.toPy();
					this.loading = true;
          // 处理辅助核算数据，将其转换为 JSON 字符串格式
					if (this.assistAccounting && this.auxiliaryAccounting.length) {
						this.form.auxiliaryAccounting = JSON.stringify(this.auxiliaryAccounting.map(value => {
							let act = this.accountingCategory.find(item => item.id == value);
							return {id: act.id, name: act.name};
						}));
					} else {
						this.form.auxiliaryAccounting = '';
					}
          // 处理数量核算单位数据
					if (this.numberAccounting && this.unit) {
						this.form.unit = this.unit;
					} else {
						this.form.unit = '';
					}
          // 调用 API 保存或更新科目数据
					this.$api.setting.subject[this.form.id ? 'update' : 'save'](Object.assign(this.form)).then(() => {
						this.loadList();
						this.showForm = false;
						this.loading = false;
					}).catch(() => {
						this.loading = false;
					})
				}
			},
			create(data) {
				this.parent = data;
				if (!data) {
					data = {level: 0, type: this.type, balanceDirection: '借'};
				}
				this.showForm = true;
				let children = this.datas.filter(value => value.parentId == data.id);
				let len = this.codeLen[data.level];
				this.len = len;
				let start = "1";
				if (children.length) {
					let code = children[children.length - 1].code;
					start = (parseInt(code.substr(code.length - len)) + 1) + "";
				}
				this.form.code = StringUtils.pad(start, 0 - (len - start.length), "0");
				this.form.type = data.type;
				this.form.parentId = data.id;
				this.form.level = data.level + 1;
				this.form.balanceDirection = data.balanceDirection;
			},
			change(data) {
				this.type = data.title;
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.setting.subject.delete(data.id).then(() => {
						this.loadList();
					})
				})
			},

      handleSelectChange(checks) {
        this.selectedSubjects = checks;
      },

      batchSetAssistAccounting() {
        // 验证是否选择了辅助核算项或清空选项
        if ((!this.batchAssistAccounting || this.batchAssistAccounting.length === 0) && !this.clearAuxiliary) {
          this.$Message('请选择要设置的辅助核算项或勾选清空辅助核算');
          return;
        }

        // 验证是否选择了科目
        if (!this.selectedSubjects || this.selectedSubjects.length === 0) {
          this.$Message('请选择要设置的科目');
          return;
        }

        this.loading = true;

        // 处理辅助核算数据，转换为 JSON 字符串格式
        let auxiliaryAccountingJson = '';
        if (this.clearAuxiliary) {
          // 清空辅助核算时使用空字符串
          auxiliaryAccountingJson = '';
        } else if (this.batchAssistAccounting && this.batchAssistAccounting.length > 0) {
          const auxiliaryAccountingData = this.batchAssistAccounting.map(value => {
            const act = this.accountingCategory.find(item => item.id == value);
            return {id: act.id, name: act.name};
          });
          auxiliaryAccountingJson = JSON.stringify(auxiliaryAccountingData);
        }

        // 过滤掉已经具有相同辅助核算设置的科目，避免重复提交
        const subjectsToUpdate = this.selectedSubjects.filter(subject => {
          const currentAux = subject.auxiliaryAccounting || '';
          return currentAux !== auxiliaryAccountingJson;
        });

        // 如果没有需要更新的科目，直接返回
        if (subjectsToUpdate.length === 0) {
          this.$Message('所选科目的辅助核算设置已经相同，无需更新');
          this.loading = false;
          this.showBatchAssistModal = false;
          this.selectedSubjects = [];
          return;
        }

        // 批量更新选中的科目，逐个更新以避免并发冲突
        const updateSequentially = async () => {
          try {
            for (const subject of subjectsToUpdate) {
              await this.$api.setting.subject.update({
                ...subject,
                auxiliaryAccounting: auxiliaryAccountingJson
              });
            }

            const actionText = this.clearAuxiliary ? '清空' : '更新';
            this.$Message.success(`成功${actionText} ${subjectsToUpdate.length} 个科目的辅助核算设置`);
            this.showBatchAssistModal = false;
            this.loadList();
            this.selectedSubjects = [];
          } catch (error) {
            this.$Message.error('批量设置失败：' + error.message);
            console.error('Batch update error:', error);
          } finally {
            this.loading = false;
          }
        };

        updateSequentially();
      },




			edit(row) {
				Api.setting.subject.checkUse(row.id).then(({data}) => {
					this.used = data;
					this.parent = this.datas.find(value => value.id == row.parentId);
					this.numberAccounting = !!row.unit;
					this.assistAccounting = !!row.auxiliaryAccounting;
					this.unit = row.unit;
					if (row.auxiliaryAccounting) {
						this.auxiliaryAccounting = JSON.parse(row.auxiliaryAccounting).map(val => val.id);
					}
					this.form = Object.assign({}, row);
					this.showForm = true;
				});
			},
			doUpload() {
				this.$refs.file.click();
			},
			fileChange(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					this.loading = true;
					this.$api.setting.subject.import(formData).then(({data}) => {
						this.$Message("亲,导入成功~");
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
					this.$refs.file.value = "";
				}
			}
		},
		mounted() {
			this.codeLen = this.currentAccountSets.encoding.split("-").map(value => parseInt(value));
			if (this.currentAccountSets.accountingStandards !== 0) {
				this.tabDatas = [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '共同',
					key: 'Common'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}];
			}
			this.loadList();
			this.loadAccountingCategory();
		}
	};
</script>

<style scoped>
	div.h-tabs.h-tabs-card {
		border-bottom: 1px solid #52abc50d;
	}

	div.h-panel-body {
		padding-top: 0px;
	}

	div.h-panel-bar {
		border-bottom: 0px solid #eeeeee;
		border-top: 1px solid #eeeeee;
	}

	.used {
		position: absolute;
		right: 50px;
		z-index: 10;
		top: 0;
	}
</style>
